import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from "react-redux";
import { sendSupportEmail } from "store/actions/user";
import UniversalInput from "components/uiComponents/UniversalInput";
import UniversalCheckbox from "components/uiComponents/UniversalCheckbox";
import UniversalTextarea from "components/uiComponents/UniversalTextarea";
import UniversalButton from "components/uiComponents/UniversalButton";
import "./SupportModal.scss";
import { ModalContext } from "../../ModalContext";

const SupportModal = () => {
  const { t } = useTranslation();

  const { email } = useSelector(state => state.user.info);
  const { handleModal } = useContext(ModalContext);
  const dispatch = useDispatch();

  const [admin, setAdmin] = useState('');
  const [company, setCompany] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (email) {
      setAdmin(email);
    }
  }, []);

  const handleChange = (value, name) => {
    switch (name) {
      case "email":
        setAdmin(value);
        break;
      case "company":
        setCompany(value);
        break;
      case "message":
        setMessage(value);
        break;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(sendSupportEmail(admin, company, message));
    handleCancel();
  };

  const handleCancel = () => {
    handleModal(null, true);
  };

  return (
    <div className="support-modal">
      <form
        onSubmit={handleSubmit}
      >
        <h2>{t('contact_support')}</h2>

        <div
          className="support-modal__input_wrapper"
        >
          <UniversalInput
            label={t('email')}
            name="email"
            type="email"
            id="email"
            placeholder={t('email')}
            onChangeValue={handleChange}
            value={admin}
            required
          />
        </div>

        <div
          className="support-modal__input_wrapper"
        >
          <UniversalCheckbox
            name="company"
            label={t('cant_find_company_name')}
            onChange={handleChange}
            checked={company}
          />
        </div>

        <div
          className="support-modal__input_wrapper"
        >
          <UniversalTextarea
            label={t('message')}
            name="Message"
            type="text"
            id="message"
            placeholder={t('message')}
            onChange={setMessage}
            value={message}
            required
          />
        </div>

        <div className="support-modal__btns">
          <div className="support-modal__btns_btn">
            <UniversalButton
              type="button"
              label={t('cancel')}
              size="lg"
              labelColor="blue"
              labelHoverColor="blue"
              backgroundColor="white"
              backgroundHoverColor="blue-light"
              onClick={handleCancel}
            />
          </div>

          <UniversalButton
            type="submit"
            label={t('send')}
            size="lg"
            labelColor="white"
            labelHoverColor="white"
            backgroundColor="orange"
            backgroundHoverColor="orange-light"
          />
        </div>
      </form>
    </div>
  );
};

export default SupportModal;
